import { AxiosResponse } from 'axios';
import { api } from './base/api';
import {  IContactApi } from './base/contactApi';
import { ContactRequest, ContactByCompanyRequest, SupportContactRequest } from '../models/request';
import {  ContactResponse } from '../models/response';
import { Result } from '../models/common/resultResponse';
import { ISupportContact } from '../models/response/supportContactResponse';
import { PaginationResponse } from '../models/common/paginationResponse';

const baseRoute: string = 'Contact';

export class ContactApi extends IContactApi {
  getContactBodyshop(request: ContactRequest): Promise<AxiosResponse<Result<ContactResponse[]>>> {
    return api.get(`${baseRoute}/contactbodyshop`, { params: request });
  }

  getContactsListByCompany(request: ContactByCompanyRequest): Promise<AxiosResponse<Result<ContactResponse[]>>> {
    return api.get(`${baseRoute}/getContactsListByCompany`, { params: request });
  }

  getContacts(request: SupportContactRequest): Promise<Result<PaginationResponse<ISupportContact>>> {
		return api.get(`${baseRoute}/getSupportContactsByCompany`, { params: request });
	}
}
